import styled from "styled-components";
import { colorsPalettes, mixins, rgba } from "@similarweb/styles";

export const StyledModalContent = styled.div`
    padding: 20px 25px 15px;
`;

export const StyledDescription = styled.div`
    margin-top: 15px;
    ${mixins.setFontVariant("body2", colorsPalettes.carbon["400"])}
`;

export const StyledTitle = styled.div`
    ${mixins.setFontVariant("h5_2", colorsPalettes.carbon["500"])}
`;

export const StyledModalFooter = styled.div`
    border-top: 1px solid ${colorsPalettes.carbon["100"]};
    display: flex;
    justify-content: flex-end;
    padding: 6px 16px;
`;

export const CUSTOM_NOT_FOUND_MODAL_STYLES_ = {
    content: { padding: 0, width: 460 },
    overlay: {
        backgroundColor: rgba(colorsPalettes.midnight["300"], 0.7),
    },
};
